import { render } from "./SelectCalculatorPage.vue?vue&type=template&id=1a20a8f4&ts=true"
import script from "./SelectCalculatorPage?vue&type=script&lang=ts"
export * from "./SelectCalculatorPage?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__